import axios from "axios";
import Config from "../../utils/Config";

class DashboardService {
  getHeaders() {
    return {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${localStorage.getItem("dbx_aff_tkn")}`,
      },
    };
  }

  async getDashboardStats() {
    try{
      const response = await axios.get(
        `${Config.devBackendDomain}affiliate/stats/deals`,
        this.getHeaders()
      );
      return {
        status: true,
        data: response.data.data,
        message: response.data.data.message || "Dashboard stats fetched successfully",
      }
    }catch(error){
      return {
        status: false,
        message: error?.response?.data?.reason || "Something went wrong",
        data: null,
      }
    }
  }
}

const dashboardService = new DashboardService();
export default dashboardService;